module.exports = __webpack_public_path__ + "img/album05_12.cd3a9b8e.jpg";